import { m8API } from 'services/production/m8';
import { normalizeM8UserFullInfo } from 'services/production/utils/normalizeM8UserFullInfo';
import { SearchClientsService } from 'types/services';

export const searchClients: SearchClientsService = async (searchBy: string) => {
  const M8UserFullInfos = await m8API.admin.findActiveUserBySubString({
    substring: searchBy,
  });

  return M8UserFullInfos.map((m8UserFullInfo) =>
    normalizeM8UserFullInfo(m8UserFullInfo).toClient(null)
  );
};
